import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import {  useNavigate } from 'react-router-dom';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { init } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getTuanInfo, register,login} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const Index = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
     const [zhiNum,setZhiNum] = useState("")
    const [tuanNum,setTuanNum] = useState("")
    const [zhiNumAct,setZhiNumAct] = useState("")

    const [reg1,setReg1] = useState("")
    const [reg2,setReg2] = useState("")
    const [reg3,setReg3] = useState("")
    const [reg4,setReg4] = useState("")
    const [mint1,setMint1] = useState("")
    const [mint2,setMint2] = useState("")

    const [puser,setPuser] = useState("")
    const [allYeIdo,setAllYeIdo] = useState("")
    const [zhiBonus1, setZhiBonus1] = useState("")
    const [zhiBonus2, setZhiBonus2] = useState("")
    const [allYe, setAllYe] = useState("")
    const [big,setBig] = useState("")
    const [small,setSmall] = useState("")
    const [smallIdo,setSmallIdo] = useState("")
    const [shareLink,setshareLink] = useState("-")
    const [pUserAddress,setPUserAddress] = useState("-")
    const [fcode,setFcode] = useState("")

    
   
    const [childs,setChilds] = useState([])
    const [levelPledge,setLevelPledge] =useState(0)

    const navigate = useNavigate()//hook事件路由跳转
    
    
    const _copy1 =()=>{
        if(props.isLogin === false){
                    message.error(t('head.请先绑定地址'))
                    return false
                }
        if(fcode.length>0){

                copy(fcode);message.success(t('share.已复制')+":"+fcode)

        }
        
    }

    const _copy =()=>{
        if(props.isLogin === false){
                    message.error(t('head.请先绑定激活地址'))
                    return false
                }
        if(shareLink.length>10){

                copy(shareLink);message.success(t('share.已复制')+":"+shareLink)

        }
        
    }

    const _copy2 =()=>{
         if(props.isLogin === false){
                    message.error(t('head.请先绑定激活地址'))
                    return false
                }
        if(pUserAddress.length>10){

                copy(pUserAddress);message.success(t('share.已复制')+":"+pUserAddress)

        }
        
    }

     const _copy3 =()=>{
        if(props.address.length>10){

                copy(props.address);message.success(t('share.已复制')+":"+props.address)

        }
        
    }

    
 

    const _getTuanInfo = () =>{
      
        if(props.address.length>0 && props.isLogin){
            getTuanInfo().then(res=>{
                if(res.code == 0){
                    setZhiNum(res.data.zhiNum)
                    setTuanNum(res.data.tuanNum)
                   setZhiNumAct(res.data.zhiNumAct)
                   setReg1(res.data.reg1)
                   setReg2(res.data.reg2)
                   setReg3(res.data.reg3)
                   setReg4(res.data.reg4)

                   setMint1(res.data.mint1)
                   setMint2(res.data.mint2)
                    
                    setBig(res.data.big)
                    setSmall(res.data.small)
                    setAllYe(res.data.allYe)
                    setAllYeIdo(res.data.allYe_ido)
                   setSmallIdo(res.data.small_ido)
                    
                    setZhiBonus1(res.data.zhiBonus1)
                    setZhiBonus2(res.data.zhiBonus2)
                    setLevelPledge(res.data.Level_pledge)
                    setshareLink(res.data.shareLink)
                    setPUserAddress(res.data.pAddress)

                   
                    setFcode(res.data.fcode)
                    
                    if(res.data.zhi!==null){
                        setChilds(res.data.zhi)
                    }
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

    



   




    useEffect(() => {
        // window.scrollTo(0, 0)
           
            _getTuanInfo()
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
            <Head/>
            

            
            
            <div  className='indexBg33  w-full lg:w-1/3 h-screen overflow-hidden pt-16'>
                <main className="h-full overflow-auto  ">
                {/*  */}
                <div onClick={()=>window.history.back()} className='w-full px-2   '>
                    <div className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                        <img alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                        <span className='text-lg oblod text-gray-100'>{t('share.我的推广')}</span>
                    </div>
                   
                </div>
                <div className='px-4 text-[11px] text-pink-500'>
                    *{t('share.分享說明：複製邀請網址和邀請地址發給好友，邀请好友手動綁定。有上级，才能作为有效钱包，才有收益')}
                </div>

                {/*  */}
                <div className='  mt-8 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='mb-1 mt-0 flex flex-row justify-start items-center'>
                        <span className=' text-sm text-gray-100'>{t('share.我的推荐链接')}</span>
                    </div>
                    
                    <div className="w-full min-h-20 mt-3 rounded-md flex flex-row items-center px-2" style={{"backgroundColor":"#ffffff","border":"1px #583C25 solid"}} >
                                <textarea rows={4}  disabled  value={shareLink}    className=' w-full   text-sm text-black  ' placeholder='' ></textarea>
                                {/* <span onClick={_maxTi} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                            </div>
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_copy} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}}  className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('index.拷贝')}</span></button>
                    </div>
                    
                </div>

                <div className='  mt-8 mx-4 px-4 pt-6 pb-6 flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='mb-1 mt-0 flex flex-row justify-start items-center'>
                        <span className=' text-sm text-gray-100'>{t('share.我的推荐人')}</span>
                    </div>
                    <div className="w-full min-h-20 mt-3 rounded-md flex flex-row items-center px-2" style={{"backgroundColor":"#ffffff","border":"1px #583C25 solid"}} >
                                <textarea  disabled  value={pUserAddress}    className=' w-full   text-sm text-black ' placeholder='' ></textarea>
                                {/* <span onClick={_maxTi} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                            </div>
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_copy2} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('index.拷贝')}</span></button>
                    </div>
                    
                </div>

                <div className='  mt-8 mx-4 px-4 pt-6 pb-6 flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='mb-1 mt-0 flex flex-row justify-start items-center'>
                        <span className=' text-sm text-gray-100'>{t('share.我的地址')}</span>
                    </div>
                    <div className="w-full min-h-20 mt-3 rounded-md flex flex-row items-center px-2" style={{"backgroundColor":"#ffffff","border":"1px #583C25 solid"}} >
                                <textarea disabled  value={props.address}  type="text"   className=' w-full  text-sm text-black ' placeholder='' ></textarea>
                                {/* <span onClick={_maxTi} className='w-1/5 h9 block text-right text-sm text-text-act'>{t('asset.全部')}</span> */}
                            </div>
                    
                    <div className=' w-full mt-5 flex flex-row justify-end items-center'>
                        <button onClick={_copy3} style={{backgroundImage: 'linear-gradient(90deg, #E94B6C 70%, #9D4EDD 100%)'}} className='w-full h-10 hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('index.拷贝')}</span></button>
                    </div>
                    
                </div>

                <div className='  mt-8 mx-4 px-4 pt-6 pb-6  flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    <div className='w-full mb-4 mt-0 flex flex-row justify-center items-center'>
                        <span className=' text-base text-gray-100'>{t('share.直推')}/{t('share.社区地址总数')}</span>
                    </div>
                    
                    
                    <div className=' w-full mt-1 flex flex-row justify-center items-center oblack text-xl text-pink-500'>
                       <span className='text-xl  mr-2'><CountUp start={0} end={zhiNum} duration="1" decimals={0} /></span>/<span className='ml-2  '><CountUp start={0} end={tuanNum} duration="1" decimals={0} /></span>
                    </div>
                    
                </div>

                

                {/* <div className=' bg-[#000F3A] mt-8 mx-4 px-4 pt-6 pb-6 rounded-xl flex flex-col items-start border border-[#0161F6]'>
                    <div className='w-full mb-4 mt-0 flex flex-row justify-center items-center'>
                        <span className=' text-lg text-gray-100'>{t('share.社区总奖金(推荐节点)')}</span>
                    </div>
                    
                    
                    <div className=' w-full mt-5 flex flex-row justify-center items-center oblack text-3xl text-[#0158F5]'>
                       <span className='text-3xl  '><CountUp start={0} end={0} duration="1" decimals={0} /> USDT</span>
                    </div>
                    
                </div> */}


                
             


                {/*  */}
                <div className='mt-6 w-full flex flex-row px-4'>
                    <span className='px-2 pb-2  text-gray-100 text-base'>{t('share.直推详情')}</span>
                </div>
                
                {/*  */}
                <div className='  mt-3 mx-4  pt-6 pb-6 flex flex-col items-start bg-[#1C182C] rounded-3xl border-[3px] border-[rgba(233,75,108,0.15)] shadow-[0_0_30px_rgba(233,75,108,0.22)]'>
                    {
                        childs.length>0?
                        childs.map((item,index)=>{
                            return(
                                <>
                                <div className='px-4 mt-2 mb-2 w-full flex flex-col items-center fontM'>
                                    <div className=' w-full flex flex-row justify-between items-center'>
                                        <div className=' text-gray-400 text-xs flex flex-col'>
                                            <span className=''>{t('share.记录时间')}</span>
                                            <span className='text-xs mt-1 text-gray-100'>{item.add_time}</span>
                                        </div>
                                        <div className=' text-gray-400 text-xs flex flex-col items-end'>
                                            <span>{t('share.社区总质押')}</span>
                                            <span className='text-xs mt-1 text-pink-500'>
                                                <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={item.big_jie}
                                                        prefix=""
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={false}
                                                        fixedDecimalScale={true}
                                                        decimalScale={4} /> VRP
                                                </span>
                                        </div>
                                    </div>
                                    <div className='mt-2 w-full flex flex-row justify-between items-center'>
                                        <div className=' text-gray-400 text-xs flex flex-col '>
                                            <span>{t('share.地址')}</span>
                                            <span className='text-xs mt-1 text-gray-100'>{item.address}</span>
                                        </div>
                                        <div className=' text-gray-400 text-xs flex flex-col items-end'>
                                            <span>{t('share.社区总人数')}</span>
                                            <span className='text-xs mt-1 text-pink-500'>
                                                {item.tuan_num}
                                                </span>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className=' w-full my-2 h-[1px] bg-stone-50/10'></div>
                               </>
                                
                            )
                        }):(
                            
                            <div  className=' w-full h-28 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-xs'>
                                    No data
                            </div>
                        )
                        }
                    
                    
                </div>
                {/*  */}

                

                </main>
                
            </div>
            

                
           {/* <Foot/> */}
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Index);
